// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"ed59d225","57":"78a26f0b","189":"e1213a1b","370":"d59361d8","583":"f84d80cf","906":"0fd2f66c"}[chunkId] + ".chunk.js";
};